angular.module('app.holidays', ['ngRoute', 'ngResource', 'angular-jwt'])
.config(['$routeProvider', ($routeProvider) => {
  $routeProvider.when('/employees/holidays', {
    template: require('./holidays.html'),
    controller: 'holidaysCtrl',
  });
}])
.controller('holidaysCtrl', ($rootScope, $translate, $scope, $resource, $route, $location, $cookies, $window, $timeout, AuthService, envService, uiCalendarConfig) => {
  $rootScope.mainmenu = 'members';
  $rootScope.menu = 'holidays';
  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }

  $scope.employees = [];
  $scope.selectAll = false;
  $scope.pickerOpen = false;
  $scope.newdate = { DATE: '', STARTTIME: '00', ENDTIME: '24', REPEAT: '0' };

  $scope.selectedEmployees = () => ($scope.employees || []).filter((e) => e.selected);
  $scope.selectedIds = () => $scope.selectedEmployees().map((e) => e.ID);
  $scope.selectedCount = () => $scope.selectedIds().length;
  $scope.allSelected = () => $scope.employees.length > 0 && $scope.selectedCount() === $scope.employees.length;

  let refetchTimer = null;
  const refetchCalendar = () => {
    if (refetchTimer) {
      $timeout.cancel(refetchTimer);
    }
    // Defer so checkbox ng-model updates finish before FullCalendar re-renders.
    refetchTimer = $timeout(() => {
      refetchTimer = null;
      if (uiCalendarConfig.calendars.holidays) {
        uiCalendarConfig.calendars.holidays.fullCalendar('refetchEvents');
      }
    }, 0);
  };

  $scope.closePicker = () => {
    $scope.pickerOpen = false;
    refetchCalendar();
  };

  $scope.togglePicker = ($event) => {
    if ($event) {
      $event.stopPropagation();
    }
    $scope.pickerOpen = !$scope.pickerOpen;
  };

  const onDocClick = () => {
    if (!$scope.pickerOpen) {
      return;
    }
    $scope.$applyAsync(() => {
      $scope.closePicker();
    });
  };
  angular.element($window.document).on('click', onDocClick);
  $scope.$on('$destroy', () => {
    angular.element($window.document).off('click', onDocClick);
  });

  $scope.toggleSelectAll = () => {
    const wantAll = !!$scope.selectAll;
    ($scope.employees || []).forEach((e) => {
      e.selected = wantAll;
    });
  };

  $scope.selectionChanged = () => {
    $scope.selectAll = $scope.allSelected();
  };

  $resource(`${APIURL}/admin/employees?count=10000`).get((data) => {
    $scope.employees = (data.users || []).map((u) => Object.assign({}, u, { selected: false }));
    $scope.selectAll = false;
  }, (err) => {
    console.error(err);
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });

  $scope.clickEvent = (event) => {
    if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
      return;
    }
    let deleteRepeat = false;
    let id = event.ID;
    if (event.REPEATKEY && confirm($translate.instant('반복 설정된 휴무 입니다. 모두 삭제 하시겠습니까?'))) {
      deleteRepeat = true;
      id = event.REPEATKEY;
    }

    $resource(`${APIURL}/admin/employees/${event.TB_EMPLOYEE_USER_ID}/holidays/${id}?REPEAT=${deleteRepeat}`).delete(() => {
      uiCalendarConfig.calendars.holidays.fullCalendar('refetchEvents');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.clickDay = (date) => {
    if ($scope.selectedCount() < 1) {
      alert($translate.instant('휴무를 설정하려면 테크니션을 선택하세요.'));
      return;
    }
    $scope.newdate = { DATE: date.format('YYYY-MM-DD'), STARTTIME: '00', ENDTIME: '24', REPEAT: '0' };
    jQuery('#modal-add').modal('show');
  };

  const isBlocked = (data) => data && (data.holidable === false || data.enableHoliday === false);

  $scope.checkEnableHoliday = () => {
    jQuery('#modal-add').modal('hide');
    const ids = $scope.selectedIds();
    if (!ids.length) {
      return;
    }

    // Check each selected detailer; confirm once if any conflict.
    const checks = ids.map((id) => $resource(
      `${APIURL}/admin/employees/${id}/holidays/holidable`,
      {
        DATE: $scope.newdate.DATE,
        STARTTIME: $scope.newdate.STARTTIME,
        ENDTIME: $scope.newdate.ENDTIME,
        REPEAT: $scope.newdate.REPEAT,
      }
    ).get().$promise);

    Promise.all(checks)
      .then((results) => {
        const blocked = results.filter(isBlocked);
        if (blocked.length) {
          const msg = blocked[0].msg || $translate.instant('휴무 설정이 불가한 테크니션이 있습니다. 계속 하시겠습니까?');
          if (!confirm($translate.instant(msg))) {
            return;
          }
          $scope.addHoliday(true);
          return;
        }
        $scope.addHoliday(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };

  $scope.addHoliday = (force) => {
    jQuery('#modal-add').modal('hide');
    const ids = $scope.selectedIds();
    if (!ids.length) {
      return;
    }

    $resource(`${APIURL}/admin/employees/holidays/bulk`, {}, { save: { method: 'POST' } })
      .save({
        EMPLOYEE_IDS: ids,
        DATE: $scope.newdate.DATE,
        STARTTIME: $scope.newdate.STARTTIME,
        ENDTIME: $scope.newdate.ENDTIME,
        REPEAT: $scope.newdate.REPEAT,
        FORCE: !!force,
      })
      .$promise
      .then(() => {
        uiCalendarConfig.calendars.holidays.fullCalendar('refetchEvents');
      })
      .catch((err) => {
        console.error(err);
        // 409 from bulk when FORCE not set — ask and retry
        if (err.status === 409 && err.data && !force) {
          const msg = err.data.msg || $translate.instant('휴무 설정이 불가한 테크니션이 있습니다. 계속 하시겠습니까?');
          if (confirm($translate.instant(msg))) {
            $scope.addHoliday(true);
          }
          return;
        }
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
  };

  $scope.uiConfig = {
    calendar: {
      height: 1200,
      editable: false,
      header: {
        left: 'month agendaWeek agendaDay',
        center: 'title',
        right: 'today prev,next',
      },
      defaultView: 'month',
      eventClick: $scope.clickEvent,
      dayClick: $scope.clickDay,
      timeFormat: 'h:mm t',
      displayEventEnd: true,
    },
  };

  $scope.eventsF = (start, end, timezone, callback) => {
    const ids = $scope.selectedIds();
    // Load aggregate calendar then filter to selection (or show all when none / all selected)
    $resource(`${APIURL}/admin/employees/-1/holidays`).get({
      START: start.format('YYYY-MM-DD'),
      END: end.format('YYYY-MM-DD'),
    }, (data) => {
      let holidays = data.holidays || [];
      if (ids.length && ids.length < ($scope.employees || []).length) {
        const idSet = {};
        ids.forEach((id) => { idSet[String(id)] = true; });
        holidays = holidays.filter((h) => idSet[String(h.TB_EMPLOYEE_USER_ID)]);
      }
      callback(holidays);
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
      callback([]);
    });
  };
  $scope.eventSources = [$scope.eventsF];
});



// WEBPACK FOOTER //
// ./src/app/employee/holidays/holidays.js